import React,{ Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app';
import './i18n';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import store from './store';
const loadingMarkup=(
  <div className="loaderwrapper">
    <span className="loader1"><h2>Loading...</h2></span></div>
)

ReactDOM.render(
  <Suspense fallback={loadingMarkup}>
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
  </Suspense>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
